module.exports = ".search-results {\r\n    height: 100%;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/planmaster/planmaster.component.css
// module id = ./src/app/component/planmaster/planmaster.component.css
// module chunks = main